import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CheckboxChangeEventDetail } from '@ionic/core';
import { encodeQueryParam, transformWeight } from 'src/helpers';

export interface CartItem {
  cartId: number;
  productId: number;
  title: string;
  img: string;
  weight: number;
  price: number;
  price_after_discount: number;
  base_discount: string;
  qty: number;
  stock: number;
  warehouseId: number;
  warehouse: string;
  checked: boolean;
}

@Component({
  selector: 'app-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss'],
})
export class CartItemComponent implements OnInit {
  @Input() isLoading: boolean;
  @Input() cartItem: CartItem;
  @Input() isLastItem: boolean;
  @Output() checkItem = new EventEmitter();
  @Output() changeAmount = new EventEmitter();
  @Output() deleteItem = new EventEmitter();

  discountAmount: number;
  originalPrice: number;
  weight: string;

  constructor(private router: Router) {}

  ngOnInit() {
    if (this.isLoading) {
      return;
    }

    this.discountAmount = parseFloat(this.cartItem.base_discount);
    this.weight = transformWeight(this.cartItem.weight);

    if (this.discountAmount > 0) {
      this.calculateOriginalPrice();
    }
  }

  onChangeAmount(mode: 'increase' | 'decrease') {
    this.changeAmount.emit({ cartId: this.cartItem.cartId, productId: this.cartItem.productId, mode });
  }

  onDeleteItem() {
    this.deleteItem.emit({ cartId: this.cartItem.cartId });
  }

  onCheckHandler(event: Event) {
    const customEvent = event as CustomEvent<CheckboxChangeEventDetail>;
    this.checkItem.emit({
      cartId: this.cartItem.cartId,
      productId: this.cartItem.productId,
      checked: customEvent.detail.checked,
    });
  }

  calculateOriginalPrice() {
    this.originalPrice = this.cartItem.price / (1 - parseFloat(this.cartItem.base_discount) / 100);
  }

  toNumber(str: string) {
    return Number(str);
  }

  qtyDisplay(num: number) {
    const isOneDigit = num?.toString().length === 1;

    if (isOneDigit) {
      return '0' + num;
    }

    return num;
  }

  goToProductDetailPage() {
    this.router.navigate(['product-detail', this.cartItem.productId], {
      queryParams: {
        selectedWarehouseId: encodeQueryParam(this.cartItem.warehouseId),
      },
    });
  }
}
